import React, { Component } from 'react'
import Axios from 'axios';
import { MDBBtn, MDBIcon, MDBCard, MDBCardBody } from 'mdbreact';

export default class AddCustomers extends Component {
    state = {
        id: '',
        name: '',
        lname: '',
        sex: '',
        age: '',
        update: false,
    }


    onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    submit = (event) => {
        event.preventDefault();

        var datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        datafrm.append("id", this.state.id);
        datafrm.append("name", this.state.name);
        datafrm.append("lname", this.state.lname);
        datafrm.append("age", this.state.age);
        datafrm.append("sex", this.state.sex);

        if (this.state.update === false) { //เช็คว่าเป็นหน้าสำหรับอัพเดตหรือไม่
            Axios.post('http://localhost/PHP/insert.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) })

        }
        else {
            Axios.post('http://localhost/PHP/update.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) }) // เมื่อเกิด error จะมาทำที่คำสั่งนี้แทน
        }

    }

    componentDidMount() {
        let data = this.props.location.data
        if (data) { // ถ้ามี data เข้ามาแสดงว่ามีการอัพเดต
            this.setState({ update: true })
            this.setState(data)
        }
    }
    render() {
        return (
            <div className='container'>
                <MDBCard>
                    <MDBCardBody>
                        <h1>{this.state.update === true ? <>อัพเดตข้อมูลสมาชิก</> : <>เพิ่มสมาชิก</>}</h1>
                        <form onSubmit={this.submit}>
                            <div className="mb-2">
                                <label>ชื่อจริง</label>
                                <input className="form-control" onChange={this.onTextChange} name="name"
                                    value={this.state.name} placeholder="กรุณาระบุชื่อจริง" required />
                            </div>

                            <div className="mb-2">
                                <label>นามสกุล</label>
                                <input className="form-control" onChange={this.onTextChange} name="lname"
                                    value={this.state.lname} placeholder="กรุณาระบุนามสกุล" required />
                            </div>

                            <div className="mb-2">
                                <label>อายุ</label>
                                <input type="number" className="form-control" onChange={this.onTextChange} name="age"
                                    value={this.state.age} placeholder="กรุณาระบุอายุ" required />
                            </div>

                            <div className="mb-2">
                                <label>เพศ</label>
                                <input className="form-control" onChange={this.onTextChange} name="sex"
                                    value={this.state.sex} placeholder="กรุณาระบุเพศ" required />
                            </div>
                            <div className="mt-3">
                                <MDBBtn type="submit" color="primary"> <MDBIcon far icon="save" /> บันทึก</MDBBtn>
                            </div>


                        </form>
                    </MDBCardBody>
                </MDBCard>
            </div>
        )
    }
}

